query getKioskCompany($languageISOCode: String, $field: String!, $value: String!) {
  kioskCompany(languageISOCode: $languageISOCode, field: $field, value: $value) {
    id
    name
    logoFileName
    topbarColorHex
    idTypes
    preferredLanguageId
    kioskId
    languages {
      id
      langISOCode
    }
    kioskWelcomeText
  }
}
